import React, {useEffect, useState} from "react";
import {Tree} from "primereact/tree";
import {PermissionEnum} from "../../utils/enums/permission-enum.js";
import "./style.css"

const TreePermissions = ({permissionsSelected, lanesSelected, maintenanceSelected, protectionProgramSelected}) => {
    const [treePermissionsSelected, setTreePermissionsSelected] = useState([]);
    const [expandedKeys, setExpandedKeys] = useState({});

    useEffect(() => {
        handleTreePermissionsSelected();
    }, [permissionsSelected]);

    const handleTreePermissionsSelected = () => {
        const permissionsToTree = [];
        for (let i = 0; i < permissionsSelected.length; i++) {
            const permission = permissionsSelected[i];
            const group = permission.group;

            let groupHasInTree = false;
            for (const key in permissionsToTree) {
                if (permissionsToTree[key].label === group) {
                    groupHasInTree = true;
                    break;
                }
            }

            if (!groupHasInTree) {
                let newPermission = {key: i, label: group, parent: true}
                expandedKeys[i] = true;
                const children = [];
                for (let j = 0; j < permissionsSelected.length; j++) {
                    if (permissionsSelected[j].group === group) {
                        children.push({
                            key: `${i}-${j}`,
                            label: permissionsSelected[j].text,
                            children: [],
                            name: permissionsSelected[j].name
                        });
                    }
                }

                newPermission.children = children;
                permissionsToTree.push(newPermission);
            }
        }

        setTreePermissionsSelected(permissionsToTree);
        setExpandedKeys(expandedKeys);
    }

    const templateToTree = (node, options) => {
        let additionalInfo = "";

        if (node.name === PermissionEnum.PASSAGE_RESTRICTED_LANE_ACCESS) {
            additionalInfo = <small className="ms-1"><b>({lanesSelected.length} câmeras selecionadas)</b></small>;
        }

        if (node.name === PermissionEnum.CAPTURE_PLACE_NOC && maintenanceSelected) {
            additionalInfo = <small className="ms-1"><b>({maintenanceSelected.label})</b></small>;
        }

        if (node.name === PermissionEnum.SOS_MANAGE_PROGRAM && protectionProgramSelected) {
            additionalInfo = <small className="ms-1"><b>({protectionProgramSelected.length} programas selecionados)</b></small>;
        }

        return (
            <div className={`p-tree-node ${node.children.length > 0 ? "p-tree-node-father" : ""}`}>
                <span className="p-tree-node-label">
                    {node.label}{additionalInfo}
                </span>
            </div>
        );
    }

    return (
        <div className="p-tree-permissions">
            {
                treePermissionsSelected.length === 0 &&
                <div className="alert alert-info p-0 mb-0">Não há permissões selecionadas.</div>
            }

            {
                treePermissionsSelected.length > 0 &&
                <Tree value={treePermissionsSelected} expandedKeys={expandedKeys}
                      nodeTemplate={templateToTree}/>
            }
        </div>
    );
}

export default TreePermissions;